// extracted by mini-css-extract-plugin
module.exports = {"__button":"ButtonSubmit___button_3f2Ss","__submit":"ButtonSubmit___submit_3J8aq"};